import React, {useMemo, useState} from "react";
import Box from "@material-ui/core/Box";
import {Grid, Paper, Typography} from "@material-ui/core";
import {GenericSidePanel} from "../../../../components/SidePanel/GenericSidePanel.comp";
import MonthRangePicker from "../../../../components/DatePickers/MonthRangePicker.comp";
import BarChart from "../../../SchoolDashboard/Assessment/components/BarChart";
import styled from "styled-components/macro";
import LoaderWithBackDrop from "../../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {getChartData} from "../../../../utils/utils";

const years = ["All Years", "2022", "2023"];

const PanelBox = styled(Paper)`
    background: #223047;
    border-radius: 10px;
    min-height: 560px;
    width: 260px;
    max-width: 260px;
    padding: 24px 16px;
    color: #fff;
    position: relative;
`;

const ParticipationByAgeTab = ({ data, loading, error }) => {
    const [monthRange, setMonthRange] = useState([null, null]);
    const [minDate, maxDate] = [new Date(2022, 0, 1), new Date(2023, 11, 31)];

    const chartData = useMemo(
        () => getChartData(
            data?.byAge,
            "age",
            "participants",
            {
                labelText: "# of Participants",
                labelFormatter: (age) => `${age} Years Old`
            }

        ),
        [data]
    );

    return (
        <Box px={2} py={3} width="100%">
            <Typography variant="h4" align="center" style={{ fontWeight: 700, marginBottom: 40 }}>
                Participation by Age
            </Typography>
            <Box display="flex" flexDirection="row" justifyContent="center" width="95%" sx={{mx:"auto"}}>
                {/* Side Panel */}
                {/*<PanelBox elevation={0}>*/}
                {/*    <GenericSidePanel*/}
                {/*        data={[years]}*/}
                {/*        headers={["Select a Time Period"]}*/}
                {/*        visible={[true]}*/}
                {/*        colourize={[false]}*/}
                {/*        defaultCheckIndices={[0]}*/}
                {/*        footers={[MonthRangePicker]}*/}
                {/*        footersData={[{ minDate, maxDate, value: monthRange }]}*/}
                {/*        footersCallbacks={[{ onChangeDate: setMonthRange }]}*/}
                {/*    />*/}
                {/*</PanelBox>*/}
                <Box flex={1} pl={13} style={{ minWidth: 0 }}>
                    {/*<ContentBox>*/}
                    {/* Top placeholder Chart */}
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <Box style={{ background: "#fff", borderRadius: 12, padding: 20 }}>
                                <BarChart
                                    labels={chartData ? chartData.labels : []}
                                    datasets={chartData ? chartData.datasets: []}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {/* Bottom Section Table */}
                    <Box mt={5}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box style={{ background: "#fff", borderRadius: 12 }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                        <tr style={{ backgroundColor: '#223047', color: '#fff' }}>
                                            <th style={{ padding: '12px 16px', textAlign: 'center' }}>Age</th>
                                            <th style={{ padding: '12px 16px', textAlign: 'center' }}># of Participants</th>
                                            <th style={{ padding: '12px 16px', textAlign: 'center' }}>% of Participants</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.byAge?.map((row, index) => (
                                                <tr key={row.age}>
                                                    <td style={{ padding: '12px 16px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
                                                        {`${row.age} Years Old`}
                                                    </td>
                                                    <td style={{ padding: '12px 16px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
                                                        {row.participants.toLocaleString()}
                                                    </td>
                                                    <td style={{ padding: '12px 16px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
                                                        {row.percentage}%
                                                    </td>
                                                </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {/*</ContentBox>*/}
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </Box>
    );
};
export default ParticipationByAgeTab;